import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * Title bar of a routed pane (saved, threads, team, search, not-available) with the phone
 * back control — T-37 · RF-26. Rendered only under the phone breakpoint, where the pane
 * covers the list; on desktop the rail stays beside the pane and each pane carries its
 * own title.
 */
@Component({
  selector: 'chat-app-pane-header',
  template: `
    <div class="chat-app-pane-header border-bottom px-3 py-2 d-flex d-md-none align-items-center gap-2">
      <a
        routerLink="/"
        class="btn btn-sm btn-light chat-app-pane-header__back"
        [attr.aria-label]="'chat.conversation.back' | translate"
      >
        <i class="ri-arrow-left-line" aria-hidden="true"></i>
      </a>
      <h5 class="my-0 text-truncate">{{ titleKey | translate }}</h5>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatAppPaneHeaderComponent {
  @Input() titleKey = '';
}
